import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomButton from '../CustomButton'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'
import { useNavigate } from 'react-router-dom'

const Banner = ({mode, bannerImg,title, main_content}) => {
  const navigate = useNavigate();
     const elementRef = useRef(null);
     const [height, setHeight] = useState(0);
     console.log(height, "banner height");
     const updateHeight = () => {
      if (elementRef.current) {
        setHeight(elementRef.current.clientHeight);
      }
    };
     
     useEffect(() => {
      updateHeight();
      window.addEventListener("resize", updateHeight);
      return () => window.removeEventListener("resize", updateHeight); 
    }, []);
    const bannerHeight = height + 300;
  return (
   <>
    {/* Banner */}
    <div className={`voloto-banner ${mode}`} style={{backgroundImage: `url(${bannerImg})`,height: `${bannerHeight}px` }} >
      <Container className=''>
        <Row className='volto-banner-header' ref={elementRef}>
          <Col lg={8} className=''>
          <div className=''>
            <h1>{title}</h1>
           </div>
          </Col>
          <Col lg={4} className=''>
          <div className=''>
            <p className='mt-4'>{main_content}</p>
          </div>
          </Col>
        </Row>
      </Container>
      
     <img className='banner-vector' src="/images/Union.svg" alt="vector" />

    </div>
   </>
        
   
   
  )
}

export default Banner;
